import { formatDate, Translate } from '../../../shared/LanguageService';
import notify from '../../../shared/feedback/notifications';
import { ICreateOrder } from '../../orders/Entities';
import { handleError } from '../../../shared/ErrorCatching';

export function subtractMinutes(date, minutes) {
    date.setMinutes(date.getMinutes() - minutes);
    return date;
}

export function addMinutes(date, minutes) {
    date.setMinutes(date.getMinutes() + minutes);
    return date;
}

export function createWeatherDetails(orderInfo, locationData) {
    const orderExecutionTime = orderInfo ? orderInfo.executionTime : 60;

    const startTime = locationData ? subtractMinutes(new Date(locationData.sunset), 15) : null;
    const endTime = startTime
        ? addMinutes(new Date(startTime.valueOf()), orderExecutionTime)
        : null;

    let formattedStartTime = startTime ? formatDate(new Date(startTime), 'HH:mm') : null;
    let formattedEndTime = endTime ? formatDate(new Date(endTime), 'HH:mm') : null;

    let formattedSunrise = locationData
        ? formatDate(new Date(locationData.sunrise), 'HH:mm')
        : null;
    let formattedSunset = locationData ? formatDate(new Date(locationData.sunset), 'HH:mm') : null;

    let selectedForecasts = locationData
        ? locationData.forecasts.filter((forecast: any) => {
              let hour = new Date(forecast.time.replace('Z', '')).getHours();
              return hour === 6 || hour === 12 || hour === 18;
          })
        : [];

    return {
        startTime,
        endTime,
        formattedStartTime,
        formattedEndTime,
        sunrise: formattedSunrise,
        sunset: formattedSunset,
        selectedForecasts
    };
}

export const createBooking = (
    order: ICreateOrder,
    createOrder,
    removeOrderCommandForBooking,
    history
) => {
    createOrder(order)
        .then((result: any) => {
            removeOrderCommandForBooking();
            notify.success(Translate('orders/notification/order-created'));
            let routeParams: any = {
                pathname: `/orders/${result.photoOrderId}`,
                search: ''
            };
            history.push(routeParams);
        })
        .catch((error: any) => handleError(error));
};

export const updateBooking = (
    updatedCalendarItem: any,
    updatePhotographer,
    orderId,
    history
) => {
    updatePhotographer(updatedCalendarItem)
        .then((result: any) => {
            notify.success(Translate('se360/photographerbooking/page/toastr/success'));
            let routeParams: any = {
                pathname: `/orders/${orderId}`,
                search: ''
            };
            history.push(routeParams);
        })
        .catch((error: any) => handleError(error));
};
